module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-debate_green.509fa0e6.svg";